// TODO: implement tablist logic, switching, css, everything else.

import { Component, h } from '@stencil/core';

@Component({
  tag: 'cwru-tabs',
  styleUrl: 'tabs.css',
  shadow: true,
})
export class Tabs {
  render() {
    return (
      <div>
        <ul role="tablist">
          <slot name="header" />
        </ul>
        <div class="content">
          <slot name="content" />
        </div>
      </div>
    );
  }
}
